module.exports = __webpack_public_path__ + "img/s3.b7ff23ec.png";